import { Table, Tbody, Td, Tr } from '@chakra-ui/react';
import { portfolioStatusColors } from '../../canopy-ui-components/components/CanopyTable/Cells/PortfolioStatusDate';
import { useCurrentColors } from '../../canopy-ui-components/hooks/UseCurrentColors/UseCurrentColors';

function Footer({ t }: any) {
    const currentColors = useCurrentColors();
    return (
        <Table
            mt="20px"
            background={currentColors.componentBg}>
            <Tbody>
                <Tr fontWeight="900">
                    <Td
                        p="0px 2px"
                        borderBottom="0px"></Td>
                    <Td
                        p="0px 2px"
                        borderBottom="0px">
                        {t('portfolio-status.nonDatafeed')}
                    </Td>
                    <Td
                        p="0px 2px"
                        borderBottom="0px">
                        {t('portfolio-status.datafeed')}
                    </Td>
                    <Td
                        p="0px 2px"
                        borderBottom="0px"></Td>
                </Tr>
                <Tr pt="10px">
                    <Td
                        background={portfolioStatusColors[0]}
                        padding="0px"
                        width="200px"
                        borderBottom="0px"></Td>
                    <Td
                        padding="0px 2px"
                        borderBottom="0px"
                        width="200px">
                        {t('portfolio-status.nonDatafeed-1', { count: 30 })}
                    </Td>
                    <Td
                        padding="0px 2px"
                        borderBottom="0px"
                        width="200px">
                        {t('portfolio-status.datafeed-1', { count: 3 })}
                    </Td>
                    <Td
                        p="0px 2px"
                        borderBottom="0px"></Td>
                </Tr>
                <Tr borderBottom="0px">
                    <Td
                        background={portfolioStatusColors[1]}
                        padding="0px"
                        width="200px"
                        borderBottom="0px"></Td>
                    <Td
                        padding="0px 2px"
                        borderBottom="0px"
                        width="200px">
                        {t('portfolio-status.nonDatafeed-2', {
                            count1: 30,
                            count2: 60,
                        })}
                    </Td>
                    <Td
                        padding="0px 2px"
                        borderBottom="0px"
                        width="200px">
                        {t('portfolio-status.datafeed-2', {
                            count1: 3,
                            count2: 7,
                        })}
                    </Td>
                    <Td
                        p="0px 2px"
                        borderBottom="0px"></Td>
                </Tr>
                <Tr>
                    <Td
                        background={portfolioStatusColors[2]}
                        padding="0px"
                        width="200px"
                        borderBottom="0px"></Td>
                    <Td
                        padding="0px 2px"
                        borderBottom="0px"
                        width="200px">
                        {t('portfolio-status.nonDatafeed-3', { count: 60 })}
                    </Td>
                    <Td
                        padding="0px 2px"
                        borderBottom="0px"
                        width="200px">
                        {t('portfolio-status.datafeed-3', { count: 7 })}
                    </Td>
                    <Td
                        p="0px 2px"
                        borderBottom="0px"></Td>
                </Tr>
            </Tbody>
        </Table>
    );
}
export default Footer;
